import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    // Keep this lightweight; console logging is sufficient for local debugging.
    // eslint-disable-next-line no-console
    console.error('Unhandled UI error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    const isProd = process.env.NODE_ENV === 'production';
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-gray-900 p-6">
        <div className="max-w-2xl w-full bg-white dark:bg-gray-800 rounded-lg shadow-2xl p-6">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
            Something went wrong
          </h2>
          <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">
            The page crashed due to an unexpected error. Reload to continue.
          </p>

          {!isProd && (
            <pre className="mt-4 text-xs overflow-auto bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 p-3 rounded">
              {String(error?.stack || error?.message || error)}
            </pre>
          )}

          <div className="mt-4 flex gap-2">
            <button
              onClick={this.handleReload}
              className="px-4 py-2 rounded bg-gradient-primary text-white text-sm font-medium"
            >
              Reload
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;

